import {
  code,
  home,
  info_circle as infoCircle,
  library,
  settings,
} from '@equinor/eds-icons';
import type { SidebarLink } from '../types';

export const globalLinks: SidebarLink[] = [
  { title: 'Home', path: '/home', icon: home },
  {
    title: 'Model Library',
    path: '/models',
    icon: library,
    nonCollapsible: true,
    children: [
      { title: 'Models', path: '/models' },
      { title: 'Simulations', path: '/models?tab=simulations' },
    ],
  },
  { title: 'Scenario Builder', path: '/scenario-builder', icon: settings },
  { title: 'API', path: '/api', icon: code },
  { title: 'About', path: '/about', icon: infoCircle },
];
